import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export interface ScreenTender {
  isUpdateTenderValid: boolean;
  isUpdateTenderInValid: boolean;
}

const initialState: ScreenTender = {
  isUpdateTenderValid: false,
  isUpdateTenderInValid: false,
};

const screenChatSlice = createSlice({
  name: "screenTender",
  initialState,
  reducers: {
    setScreenTenderValidUpdate: (state, action: PayloadAction<boolean>) => {
      state.isUpdateTenderInValid = action.payload;
    },
    setScreenTenderInValidUpdate: (state, action: PayloadAction<boolean>) => {
      state.isUpdateTenderInValid = action.payload;
    },
  },
});

export const { setScreenTenderValidUpdate, setScreenTenderInValidUpdate } = screenChatSlice.actions;
export const selectScreenTenderState = (state: RootState) =>
  state.screenTender;
export default screenChatSlice.reducer;
